export const DOMAIN = "/"
export const RELEASE_NUM = "WEB-25.04.2284"
export const MODULE_NAME = "bo-web"
export const IS_ONLINE = true
